<section class="py-4">

    <div class="card mx-md-4 mx-2 mb-4">
        <div class="card-body row align-items-end">
            <div class="col-lg-6 col-12 p-2">
                <label for="nome">Nome</label>
                <input [readonly]="desativarInputsEBotoes" [formControl]="form.controls.nome" type="text" id="nome" class="form-control">
                <app-msg-erro [control]="form.controls.nome"></app-msg-erro>
            </div>
            <div class="col-lg-6 col-12 p-2">
                <label for="desc">Descrição</label>
                <input [readonly]="desativarInputsEBotoes" [formControl]="form.controls.descricao" type="text" id="desc" class="form-control">
                <app-msg-erro [control]="form.controls.descricao"></app-msg-erro>
            </div>
        </div>
    </div>

    <div *ngIf="listaLaudo.length>0" class="card mx-md-4 mx-2">

        <div class="card-header bg-white">
            <h2>Laudos</h2>
        </div>

        <div class="card-body p-0">
            <div class="row">

                <ng-container *ngFor="let c of listaLaudo; let i = index">
                    <div class="col-12 col-md-6">
                        <div class="border border-light d-block h-100">
                            <div class="p-lg-4 p-2 row">
                                <div class="fw-500 py-2">
                                    {{c.nomeTipoLaudo}} &nbsp;
                                </div>
                                <app-input-range-quantidade-preco [disabled]="desativarInputsEBotoes" *ngIf="c.range.length>0" [formList]="c.range"></app-input-range-quantidade-preco>
                                <div class="p-1 mt-1 rounded bg-light w-100 d-flex align-items-center justify-content-between">
                                    <app-checkbox  [disabled]="desativarInputsEBotoes" [(checked)]="c.cortesia" label='Cortesia'></app-checkbox>
                                    <i *ngIf="c.cortesia" class="text-danger f-12">Ao marcar esta opção a consulta não será cobrada</i>
                                  </div>
                            </div>
                        </div>
                    </div>

                </ng-container>

            </div>
        </div>
    </div>


    <div *ngIf="listaLaudoCombinado.length>0" class="card mx-md-4 mt-4 mx-2">

        <div class="card-header bg-white">
            <h2>Laudos Combinados</h2>
        </div>


        <div *ngIf="listaLaudoCombinado.length==0" class="card-body text-secondary text-center fw-500">
            Nenhum registro encontrado
        </div>

        <div *ngIf="listaLaudoCombinado.length>0" class="card-body p-0">
            <div class="row">

                <ng-container *ngFor="let c of listaLaudoCombinado; let i = index">
                    <div class="col-12 col-md-6">
                        <div class="border border-light d-block h-100">
                            <div class="p-2 p-lg-4 row">
                                <div class="fw-500 py-2">
                                    {{c.nomeTipoLaudo}}
                                </div>
                                <app-input-range-quantidade-preco [disabled]="desativarInputsEBotoes" *ngIf="c.range.length>0" [formList]="c.range"></app-input-range-quantidade-preco>
                                <div class="p-1 mt-1 rounded bg-light w-100 d-flex align-items-center justify-content-between">
                                    <app-checkbox  [disabled]="desativarInputsEBotoes" [(checked)]="c.cortesia" label='Cortesia'></app-checkbox>
                                    <i *ngIf="c.cortesia" class="text-danger f-12">Ao marcar esta opção a consulta não será cobrada</i>
                                  </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>


    <div class="mb-5 py-5 mx-2 mx-md-4 d-flex justify-content-end">
        <button *ngIf="!desativarInputsEBotoes" (click)="confirmar()" class="btn btn-success btn-lg px-5">
            Confirmar
        </button>
    </div>

</section>
